import { useState, type ReactNode } from 'react';
import { IconChevronDown } from '@tabler/icons-react';
import s from './moretabs.module.css';

export interface MoreTab<K extends string> {
  key: K;
  label: string;
  /** số hiện sau nhãn (badge) */
  n?: number;
}

/** Nhóm tab ở đầu trang: tab chính hiện thẳng, tab còn lại trong nút "Thêm ▾" (hiện tên tab đang chọn khi ở trong menu). */
export function MoreTabs<K extends string>({ label, value, main, more, onChange, moreLabel = 'Thêm', pad = false }: { pad?: boolean; label: string; value: K; main: readonly MoreTab<K>[]; more: readonly MoreTab<K>[]; onChange: (k: K) => void; moreLabel?: string }): ReactNode {
  const [open, setOpen] = useState(false);
  const inMore = more.find((x) => x.key === value);
  const pick = (k: K) => { onChange(k); setOpen(false); };
  return (
    <div className={`${s.seg} ${pad ? s.pad : ''}`} role="tablist" aria-label={label}>
      {main.map((x) => (
        <button key={x.key} type="button" role="tab" className={s.btn} aria-selected={value === x.key} onClick={() => pick(x.key)}>
          {x.label}
          {x.n ? <span className={s.n}>{x.n}</span> : null}
        </button>
      ))}
      {more.length > 0 && (
        <span className={s.wrap}>
          <button type="button" className={s.btn} aria-haspopup="menu" aria-expanded={open} aria-pressed={!!inMore} onClick={() => setOpen(!open)}>
            {inMore ? inMore.label : moreLabel}
            <IconChevronDown size={14} aria-hidden="true" />
          </button>
          {open && (
            <div className={s.menu} role="menu" aria-label={`${label} khác`}>
              {more.map((x) => (
                <button key={x.key} type="button" role="menuitemradio" aria-checked={value === x.key} className={s.item} onClick={() => pick(x.key)}>
                  {x.label}
                  {x.n ? <span className={s.n}>{x.n}</span> : null}
                </button>
              ))}
            </div>
          )}
        </span>
      )}
    </div>
  );
}
